import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cpd_token');
    const storedAdmin = localStorage.getItem('cpd_admin');
    
    if (token && storedAdmin) {
      setAdmin(JSON.parse(storedAdmin));
      // Verify token is still valid
      authAPI.getMe()
        .then((res) => {
          setAdmin(res.data);
          localStorage.setItem('cpd_admin', JSON.stringify(res.data));
        })
        .catch(() => {
          logout();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await authAPI.login({ email, password });
    const { access_token, admin: adminData } = response.data;
    
    localStorage.setItem('cpd_token', access_token);
    localStorage.setItem('cpd_admin', JSON.stringify(adminData));
    setAdmin(adminData);
    
    return adminData;
  };

  const register = async (email, password, name) => {
    const response = await authAPI.register({ email, password, name });
    const { access_token, admin: adminData } = response.data;
    
    localStorage.setItem('cpd_token', access_token);
    localStorage.setItem('cpd_admin', JSON.stringify(adminData));
    setAdmin(adminData);
    
    return adminData;
  };

  const updateAdmin = (patch) => {
    setAdmin((prev) => {
      const next = { ...(prev || {}), ...patch };
      localStorage.setItem('cpd_admin', JSON.stringify(next));
      return next;
    });
  };

  const logout = () => {
    localStorage.removeItem('cpd_token');
    localStorage.removeItem('cpd_admin');
    setAdmin(null);
  };

  const value = {
    admin,
    loading,
    login,
    register,
    logout,
    updateAdmin,
    isAuthenticated: !!admin,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
